import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../../../components";
import { useHandlingFee } from "../../context/HandlingFeeContext";
import { BettingRecord } from "./components";
import styles from "./style.module.scss";
const HandlingFeeStatement = () => {
  const { t } = useTranslation();
  const { levels } = useHandlingFee();
  const [activeTab, setActiveTab] = useState("betting_amount");
  const tabItems = [
    {
      key: "betting_amount",
      title: t("handlingFee.tab.bettingamount"),
      component: <BettingRecord />,
      destroyOnClose: true,
    },
  ];

  const [tabs, setTabs] = useState(tabItems);

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  useEffect(() => {
    setTabs([...tabItems, ...levels]);
  }, [levels]);

  return (
    <div className={styles.container}>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={[...tabs]} />
    </div>
  );
};

export default HandlingFeeStatement;
